import React from "react";
import styled from "styled-components";
import { CSVLink } from "react-csv";

const ButtonAction = styled.button`
color: #0288d1;
background-color: transparent;
font-size: 14px;
font-weight: 500;
line-height: 20px;
font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
width: ${props => props.width? props.width + '%':'max-content'};
padding: 6px 16px;
border: 1px solid #0288d1;
cursor:pointer;
text-transform: uppercase;
margin:auto;
margin-bottom:8px;
&:hover{
  color: #fff;
  background-color: #0288d1;
} 
`;
function CSVButton (props){
  return (
    <CSVLink data={props.data?props.data:[]} filename={'reporte_ventas_'+props.concepto+'.csv'}>
      <ButtonAction >CSV</ButtonAction>
    </CSVLink>
  );
}
export default CSVButton;